import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SegmentLogo from '@segment/matcha/components/SegmentLogo';
import Button from '@segment/matcha/components/Button';
import ButtonText from '@segment/matcha/components/ButtonText';
import DesktopNavBase, * as DesktopNav from '@segment/matcha/recipes/Navigation/DesktopNavigation';
import * as Navbar from '@segment/matcha/recipes/Navigation/DesktopNavigation/Navbar';
import useNavigation from '@segment/matcha/recipes/Navigation/useNavigation';
import { usePageConfig } from '@segment/contexts/page';
import utilityData from '../data/utility';
import Products from './Dropdowns/Products';
import Docs from './Dropdowns/Docs';
import Resources from './Dropdowns/Resources';
import Solutions from './Dropdowns/Solutions';
import SupportMenu from './SupportMenu';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement;
  var pageConfig = usePageConfig();

  var _useNavigation = useNavigation(),
      getDropdownLinkProps = _useNavigation.getDropdownLinkProps;

  var _utilityData = utilityData(pageConfig),
      demoButton = _utilityData.demoButton,
      loginButton = _utilityData.loginButton,
      links = _utilityData.links,
      signUpButton = _utilityData.signUpButton;

  return _jsxs(DesktopNavBase, {
    children: [_jsxs(DesktopNav.UtilityNav, {
      announcement: announcement,
      children: [links.map(function (el) {
        return _jsx(SupportMenu, {
          links: el
        }, el.title);
      }), _jsx(ButtonTextSmall, {
        size: "small",
        variant: "mono",
        href: loginButton.url,
        children: loginButton.text
      })]
    }), _jsxs(DesktopNav.Navbar, {
      children: [_jsx(Navbar.Brand, {
        href: "/",
        children: _jsx(SegmentLogo, {
          alt: "Twilio, Inc."
        })
      }), _jsxs(Navbar.Content, {
        role: "menubar",
        children: [_jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Products"
          }, getDropdownLinkProps("products")), {}, {
            children: _jsx(Products, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Solutions"
          }, getDropdownLinkProps("solutions")), {}, {
            children: _jsx(Solutions, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, {
            role: "menuitem",
            title: "Pricing",
            href: "/pricing/"
          })
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Docs"
          }, getDropdownLinkProps("docs")), {}, {
            children: _jsx(Docs, {})
          }))
        }), _jsx("li", {
          role: "none",
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            role: "menuitem",
            title: "Resources"
          }, getDropdownLinkProps("resources")), {}, {
            children: _jsx(Resources, {})
          }))
        })]
      }), _jsxs(Navbar.Aside, {
        children: [_jsx(ButtonText, {
          href: signUpButton.url,
          size: "small",
          variant: "mono",
          children: signUpButton.text
        }), _jsx(Button, {
          size: "medium",
          color: "primary",
          variant: "filled",
          href: demoButton.url,
          children: demoButton.text
        })]
      })]
    })]
  });
};

export default DesktopNavigation;

var ButtonTextSmall = /*#__PURE__*/_styled(ButtonText, true ? {
  target: "e1uv8xvu0"
} : {
  target: "e1uv8xvu0",
  label: "ButtonTextSmall"
})("font-size:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.buttonSmall;
}, ";" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));